import Sidebar from '../components/Sidebar';

export default class ArticlePage {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.sidebarTopEl = this.el.querySelector('[data-sidebar-top]');
    this.sidebarBottomEl = this.el.querySelector('[data-sidebar-bottom]');

    this.sidebarTop = new Sidebar(this.sidebarTopEl);
    this.sidebarBottom = new Sidebar(this.sidebarBottomEl);
  }

  onSectionUnload() {
    this.sidebarTop.unload();
    this.sidebarBottom.unload();
  }
}
